define 'controller/HomepageController', ['jquery', 'lib/kryptonite'], ($) ->
  class HomepageController
  
    constructor: (@$el) ->
      @_closeNewsletterPopin()
      @_closeIntroLayerPopin()
      @_fullWidth()

    _closeNewsletterPopin: ->
      $('body').on 'click', '.newsletter-flyout .close', (e) ->
        $('.newsletter-flyout-container').removeClass('open')

    _closeIntroLayerPopin: ->
      $('body').on 'click', '.homepage-intro-layer .close', (e) ->
        $('.homepage-intro-layer-container').removeClass('open')

    _fullWidth: ->
      self = @
      self._makeHomepageContainerFullWidth()
      $(window).on 'resize', ->
        setTimeout (->
          self._makeHomepageContainerFullWidth()
          return
          ), 200
        

    _makeHomepageContainerFullWidth: ->
      homepageContainer = $('.homepage')
      viewportWidth = $(window).width()
      homepageContainer.offset({left: 0 }).width(viewportWidth)
      